var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.defaultValue)?_c('span',[_vm._v(_vm._s(_vm.defaultValue))]):(_vm.$apollo.loading || !_vm.attribute)?_c('span',[_vm._v("---")]):_c('div',{class:_vm.statusClass},[_vm._v(_vm._s(_vm.value || '-'))])])}
var staticRenderFns = []

export { render, staticRenderFns }